/**
 * Main script for Tomek Walas Photos website
 * Handles common functionality across all pages
 */ // Mobile navigation toggle
document.addEventListener('DOMContentLoaded', ()=>{
    // Mobile menu toggle
    const menuToggle = document.querySelector('.menu-toggle');
    const navMenu = document.querySelector('.nav-menu');
    if (menuToggle && navMenu) menuToggle.addEventListener('click', ()=>{
        navMenu.classList.toggle('open');
        menuToggle.classList.toggle('active');
        // Update aria-expanded attribute for accessibility
        const isExpanded = navMenu.classList.contains('open');
        menuToggle.setAttribute('aria-expanded', isExpanded.toString());
    });
    // Dropdown menu for galleries
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    dropdownToggles.forEach((toggle)=>{
        toggle.addEventListener('click', (e)=>{
            e.preventDefault();
            const parent = toggle.closest('.dropdown');
            // Close other open dropdowns
            document.querySelectorAll('.dropdown').forEach((dropdown)=>{
                if (dropdown !== parent) dropdown.classList.remove('open');
            });
            // Toggle current dropdown
            parent?.classList.toggle('open');
        });
    });
    // Close dropdowns when clicking outside
    document.addEventListener('click', (e)=>{
        const target = e.target;
        if (!target.closest('.dropdown')) document.querySelectorAll('.dropdown').forEach((dropdown)=>{
            dropdown.classList.remove('open');
        });
    });
    // Close mobile menu when clicking a link
    const navLinks = document.querySelectorAll('.nav-menu a');
    navLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            // Only close if it's mobile view (checking if menu toggle is visible)
            if (window.getComputedStyle(menuToggle).display !== 'none') {
                navMenu.classList.remove('open');
                menuToggle.classList.remove('active');
                menuToggle.setAttribute('aria-expanded', 'false');
            }
        });
    });
});
// Handle current year in copyright
const $1ccc8d3c866b7484$var$yearSpan = document.querySelector('.copyright-year');
if ($1ccc8d3c866b7484$var$yearSpan) $1ccc8d3c866b7484$var$yearSpan.textContent = new Date().getFullYear().toString();


//# sourceMappingURL=about.2e2a03df.js.map
